import Vue    from 'vue';
import App    from './App.vue';
import router from './router';
import store  from './store';
import i18n   from './i18n';

import 'pixelstein-vue-app-package/src/update-checker';
import 'pixelstein-vue-app-package/src/page-height-notifier';

import ConfigLoader from 'pixelstein-vue-app-package/src/plugins/config-loader';

import ApiErrorHandlerPlugin
  from '@pixelstein/api-error-handler-plugin/dist/ApiErrorHandlerPlugin';

const apiErrorHandlerPlugin = new ApiErrorHandlerPlugin();
Vue.use(apiErrorHandlerPlugin);

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';

Vue.use(VueToast);

Vue.config.productionTip = false;

(async () => {

  await ConfigLoader();

  const app = new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
  }).$mount('#app');

  if (process.env.NODE_ENV === 'development') {
    window.vm = app;
  }

})();
